import React, { useEffect, useState } from "react";
import "../css/SetupForm.css";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import CuSpinner from "../../common_component/component/CuSpinner";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useItemsFilterNew } from "../../_helper/actions/app/items";
import CuDropdown from "../../common_component/component/CuDropdown";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { CLOSE_ICON } from "../../cufront-assets/icons/Icons";
import CustomerAddressForm from "./CustomerAddressForm";
import InvoiceDetails from "./InvoiceDetails";
import { userRoleAtom } from "../../components/admin/setup/atom/Atom";
import MedicineDataForm from "./MedicineDataForm";
import LanguageTranslation from "./LanguageTranslation";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCurrentRole } from "../../_helper/constant/Permission";
import CreateRoles from "../../roles_and_permissions/components/CreateRoles";
import UserCreateRoles from "../../roles_and_permissions/components/UserCreateRoles";
import CuInput from "../../all-patient/components/CuInput";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import MedicineStockForm from "./MedicineStockForm";
import BatchForm from "./BatchForm";
import LabTestForm from "./LabTestForm";
import ThresholdForm from "./ThresholdForm";
import StepCreation from "./StepCreation";
import { fieldsDetail } from "../../components/admin/DndTemplate/DndAtom/DndTemplateAtom";
import CuMultiSelectBox from "../../common_component/component/CuMultiSelectBox";

const SetupForm = ({ selectedOption }) => {
  const [formData, setFormData] = useState({
    price: 0,
    services: [],
    currency: "INR",
    medicine_data: [],
    group_item: [],
  });
  const [address, setAddress] = useState({
    billing_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
    communication_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
  });
  const [servicesOptions, setServicesOptions] = useState([]);
  const [fields, setFields] = useAtom(fieldsDetail);
  const [transactionTypeOptions, setTransactionTypeOptions] = useState([]);
  const [itemsOptions, setItemsOptions] = useState([]);
  const [medicineOptions, setMedicineOptions] = useState([]);
  const [clinic] = useAtom(clinicAtom);
  const [doctorData] = useAtom(userRoleAtom);
  const [searchInput, setSearchInput] = useState({
    medicine: "",
    tagType: "",
    tag: "",
    serviceType: "",
    services: "",
    uom: "",
    steps: "",
  });

  const [tagTypeOptions, setTagTypeOptions] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const [stepOptions, setStepOptions] = useState([]);
  const [searchParams] = useSearchParams();
  const { role_id } = useCurrentRole();
  const mode = searchParams.get("mode");
  const groupId = searchParams.get("group_id");
  const optionId = searchParams.get("option_id");
  const id = searchParams.get("id");
  const navigate = useNavigate();

  const handleSearch = (val, label) => {
    setSearchInput({
      medicine: "",
      item: "",
      tagType: "",
      tag: "",
      serviceType: "",
      services: "",
      uom: "",
      [label]: val,
    });
  };

  const clearSearch = () => {
    setSearchInput({
      medicine: "",
      tagType: "",
      item: "",
      tag: "",
      serviceType: "",
      services: "",
      uom: "",
      steps: "",
    });
  };

  const handleGetTagTypes = (response) => {
    return response?.data;
  };

  const handleGetTags = (response) => {
    return response?.data;
  };

  const handleGetMedicineData = (response) => {
    return response?.data;
  };

  const handleGetServiceType = (response) => {
    return response?.data;
  };

  const handleGetTransactionType = (response) => {
    return response?.data;
  };

  const handleGetServices = (response) => {
    return response?.data;
  };

  const handleGetItems = (response) => {
    return response?.data;
  };

  const handleGetLocation = (response) => {
    return response?.data;
  };
  const handleGetStep = (response) => {
    return response?.data;
  };

  const handleGetEditData = (response) => {
    if (selectedOption?.value === "Mode of Payment") {
      const modifiedData = {
        id: response?.data?.id,
        mode_of_payment: response?.data?.type,
      };
      return modifiedData;
    }
    return response?.data;
  };

  const { data: services } = useItemsFilterNew(
    ApiEndPoint.CLINIC_SERVICES,
    `?action=getClinicServices&frontend=True&clinic_id=${clinic?.id}&name_of_service__icontains=${searchInput?.services}`,
    clinic?.id && searchInput?.services ? true : false,
    handleGetServices
  );

  const { data: transactionTypes } = useItemsFilterNew(
    ApiEndPoint.NO_SEQ_TRANSACTION_TYPE,
    `?action=getNoSeqTransactionType&frontend=True&clinic_id=${clinic?.id}`,
    clinic?.id && selectedOption?.value === "Number Sequence" ? true : false,
    handleGetTransactionType
  );

  const { data: medicineData } = useItemsFilterNew(
    ApiEndPoint.QP_CM_MEDICINE_DATA,
    `?action=getMedicineData&medicine_name__icontains=${searchInput?.medicine}&medicine_data=True`,
    clinic?.id && searchInput?.medicine?.length > 0 ? true : false,
    handleGetMedicineData
  );

  const { data: tagTypes } = useItemsFilterNew(
    ApiEndPoint.QP_CM_TAG_TYPES,
    `?action=getTagTypes&frontend=True&clinic_id=${clinic?.id}&search=${searchInput?.tagType}`,
    searchInput?.tagType?.length > 0 && clinic?.id ? true : false,
    handleGetTagTypes
  );

  const { data: tags } = useItemsFilterNew(
    ApiEndPoint.QP_CM_TAGS,
    `?action=getTags&frontend=True&tag_type=${formData?.group_for}&clinic_id=${clinic?.id}&search=${searchInput?.tag}`,
    clinic?.id && searchInput?.tag?.length > 0 && formData?.group_for
      ? true
      : false,
    handleGetTags
  );

  const { data: serviceTypes } = useItemsFilterNew(
    ApiEndPoint.CLINIC_SERVICES,
    `?action=getServiceType&backend=True&clinic_id=${clinic?.id}&name=${searchInput?.serviceType}`,
    clinic?.id && searchInput?.serviceType?.length > 0 ? true : false,
    handleGetServiceType
  );

  const { data: items } = useItemsFilterNew(
    ApiEndPoint.INVENTORY,
    `?action=getItem&backend=True&clinic_id=${clinic?.id}&name=${searchInput?.item}`,
    clinic?.id && searchInput?.item?.length > 0 ? true : false,
    handleGetItems
  );

  const { data: locations } = useItemsFilterNew(
    ApiEndPoint.INVENTORY,
    `?action=getWard&backend=True&clinic_id=${clinic?.id}&name=${searchInput?.ward}`,
    clinic?.id && searchInput?.ward?.length > 0 ? true : false,
    handleGetLocation
  );

  const { data: steps } = useItemsFilterNew(
    ApiEndPoint.IPD,
    `?action=getStep&backend=True&clinic_id=${clinic?.id}&name=${searchInput?.steps}`,
    clinic?.id && searchInput?.steps?.length > 0 ? true : false,
    handleGetStep
  );

  // console.log(searchInput);

  const { data: editData } = useItemsFilterNew(
    selectedOption?.offset,
    `${selectedOption?.query}&clinic_id=${clinic?.id}${
      selectedOption?.isDrFilter ? `&doctor_id=${role_id}` : ""
    }&id=${id}`,
    selectedOption?.offset && mode !== "create" && clinic?.id && id
      ? true
      : false,
    handleGetEditData
  );

  useEffect(() => {
    if (steps) {
      const options = steps?.map((ttype) => {
        return {
          id: ttype?.id,
          key: ttype?.id,
          value: ttype?.id,
          text: ttype?.name,
          name: ttype?.name,
        };
      });
      setStepOptions(options);
    }
  }, [steps]);

  useEffect(() => {
    if (tagTypes) {
      const options = tagTypes?.map((ttype) => {
        return {
          key: ttype?.id,
          value: ttype?.id,
          text: ttype?.name,
        };
      });
      setTagTypeOptions(options);
    }
  }, [tagTypes]);

  useEffect(() => {
    if (items) {
      const options = items?.map((ttype) => {
        return {
          key: ttype?.id,
          value: ttype?.id,
          text: ttype?.name,
        };
      });
      setItemsOptions(options);
    }
  }, [items]);

  useEffect(() => {
    if (tags) {
      const options = tags?.map((tag) => {
        return {
          key: tag?.id,
          value: tag?.id,
          text: tag?.name,
        };
      });
      setTagOptions(options);
    }
  }, [tags]);

  useEffect(() => {
    if (medicineData) {
      const options = medicineData?.map((med) => ({
        key: med?.id,
        value: med?.id,
        text: med?.medicine_name,
      }));
      setMedicineOptions(options);
    }
  }, [medicineData]);

  useEffect(() => {
    if (transactionTypes) {
      const options = transactionTypes?.map((tType) => ({
        key: tType?.id,
        value: tType?.id,
        text: tType?.transaction_type,
      }));
      setTransactionTypeOptions(options);
    }
  }, [transactionTypes]);
  console.log(transactionTypeOptions);

  useEffect(() => {
    if (services) {
      const soptions = services?.map((service) => ({
        key: service?.id,
        value: service?.id,
        text: service?.name_of_service,
      }));
      setServicesOptions(soptions);
    }
  }, [services]);

  useEffect(() => {
    if (editData) {
      if (selectedOption?.value === "Number sequence") {
        setFormData({
          ...editData,
          transaction_type: editData?.transaction_type?.id,
        });
        return;
      }
      setFormData(editData);
      setFields(editData?.form); // Step
      if (selectedOption?.value === "Customer Details") {
        const { billing_address, communication_address } = editData;
        setAddress({ billing_address, communication_address });
      }
    }
  }, [editData]);

  // console.log("Lets See", formData);

  const closeForm = () => {
    navigate(`/new/setup?group_id=${groupId}&option_id=${optionId}`);
  };

  const handleCancel = () => {
    closeForm();
  };

  console.log(formData);
  const handleChange = (value, label) => {
    const exactLabel = label?.replace(/ /g, "_").toLowerCase();
    console.log("value & label", value, label);
    // console.log();

    if (label === "Currency") {
      setFormData((prev) => ({
        ...prev,
        currency: "INR",
      }));
    }
    if (label === "Select services") {
      const selectedService = services?.find(
        (service) => service?.id === value
      );
      setFormData((prev) => ({
        ...prev,
        price: Number(prev?.price) + Number(selectedService?.price),
        services: [...prev?.services, selectedService],
      }));
      clearSearch();
      setServicesOptions([]);
      return;
    }
    if (label === "Select Medicines") {
      const medicine = handleAddMedicine(value);
      setFormData((prev) => ({
        ...prev,
        medicine_data: [...prev?.medicine_data, medicine],
      }));
      return;
    }
    if (label === "Select Tags") {
      const selectedTag = tags?.find((tag) => tag?.id === Number(value));
      setFormData((prev) => ({
        ...prev,
        group_item: [...prev?.group_item, selectedTag],
      }));
      return;
    }
    if (label === "Service Type") {
      setFormData((prev) => ({
        ...prev,
        service_type: { id: null, name: value },
      }));
      return;
    }
    if (label === "item") {
      setFormData((prev) => ({
        ...prev,
        item: { id: null, name: value },
      }));
      return;
    }
    if (label === "ward") {
      setFormData((prev) => ({
        ...prev,
        ward: { id: null, name: value },
      }));
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [exactLabel]: !isNaN(parseInt(value)) ? value : value.toUpperCase(),
    }));
  };

  const handleAddMedicine = (medicineId) => {
    const selectedMedicine = medicineData?.find(
      (med) => med?.id === medicineId
    );
    return selectedMedicine;
  };

  const handleDeleteMedicine = (medicine) => {
    if (mode !== "view") {
      setFormData((prev) => {
        const filteredMedicines = prev?.medicine_data?.filter(
          (med) => med?.id !== medicine?.id
        );
        return {
          ...prev,
          medicine_data: filteredMedicines,
        };
      });
    }
  };

  const handleDeleteTag = (tag) => {
    if (mode !== "view") {
      setFormData((prev) => {
        const filteredTags = prev?.group_item?.filter(
          (tags) => tags?.id !== tag?.id
        );
        return {
          ...prev,
          group_item: filteredTags,
        };
      });
    }
  };

  const postMutation = useCreateItem(selectedOption?.offset);
  const updateMutation = useSecureUpdateItem(selectedOption?.offset);

  const handleSave = (e) => {
    e.preventDefault();
    let payload = {
      clinic_id: clinic?.id,
      clinic: clinic?.id,
      name: formData?.label,
      doctor_user: doctorData?.id,
      action: selectedOption?.postAction,
      frontend: "True",
      sort: 1,
      status: "test",
      tag_type: [selectedOption?.tagId],
      form: fields,
      ...formData,
    };

    console.log("Form Data", formData);

    if (selectedOption?.value === "Package Master") {
      payload = {
        clinic_id: clinic?.id,
        clinic: clinic?.id,
        name: formData?.label,
        status: "test",
        doctor_user: doctorData?.id,
        action: selectedOption?.postAction,
        frontend: "True",
        sort: 1,
        ...formData,
        discount_type: "percentage",
        services: formData?.services?.map((ele) => ele?.id),
      };
    }

    if (selectedOption?.value === "RX Group") {
      payload = {
        clinic_id: clinic?.id,
        doctor_user: doctorData?.id,
        action: selectedOption?.postAction,
        frontend: "True",
        status: "draft",
        ...formData,
        medicine_data: formData?.medicine_data,
        medicine_table: {
          ok: "ok",
        },
      };
    }

    if (selectedOption?.value === "TAG Group") {
      payload = {
        action: selectedOption?.postAction,
        group_name: formData?.group_name,
        clinic_id: clinic?.id,
        backend: "True",
        doctor_user: doctorData?.id,
        group_for: formData?.group_for,
        group_item: formData?.group_item,
      };
    }

    if (selectedOption?.value === "Add Language") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        backend: "True",
        name: formData?.name,
        label: formData?.name,
      };
    }
    if (selectedOption?.value === "Service Master") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        backend: "True",
        currency: "INR",
        ...formData,
        service_type: formData?.service_type?.id,
        status: "draft",
        sort: 1,
        type: "NA",
      };
    }
    if (selectedOption?.value === "Medicine Stock") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        medicine_name: formData?.medicine_name,
        genric_name: formData?.genric_name,
        master_data_id: Number(formData?.master_data_id),
        uom: formData?.uom,
        quantity: Number(formData?.quantity),
        expiry_date: formData?.expiry_date,
        price: Number(formData?.price),
      };
    }
    if (selectedOption?.value === "Service Type") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        name: formData?.name,
        description: formData?.description,
        offset: "medicine",
      };
    }
    if (selectedOption?.value === "Categories") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        name: formData?.name,
        display_name: formData?.display_name,
      };
    }
    if (selectedOption?.value === "Mode of Payment") {
      payload = {
        action: selectedOption?.postAction,
        clinic_id: clinic?.id,
        type: formData?.mode_of_payment,
        status: "draft",
      };
    }

    if (mode === "edit" && formData?.id) {
      updateMutation.mutate(
        {
          id: null,
          data: {
            ...payload,
            id: formData?.id,
            action: selectedOption?.editAction,
          },
        },
        {
          onSuccess: () => closeForm(),
          onError: (err) => toast.error(err.response.data.message),
        }
      );
      return;
    }
    postMutation.mutate(payload, {
      onSuccess: () => closeForm(),
      onError: (err) => toast.error(err.response.data.message),
    });
  };

  const handleDeleteService = (service) => {
    if (mode !== "view") {
      setFormData((prev) => {
        const filteredServices = prev?.services?.filter(
          (src) => src?.id !== service?.id
        );

        return {
          ...prev,
          services: filteredServices,
          price: Number(prev?.price) - Number(service?.price),
        };
      });
    }
  };

  const handleEdit = () => {
    navigate(
      `/new/setup?group_id=${groupId}&option_id=${optionId}&mode=edit&id=${id}`
    );
  };

  const handleSelectOption = (data, label) => {
    console.log(label);
    if (label === "medicine_name") {
      setFormData((prev) => ({
        ...prev,
        [label]: data?.medicine_name,
        master_data_id: data?.id,
        genric_name: data?.generic_name?.name,
      }));
    } else if (label === "uom") {
      setFormData((prev) => ({
        ...prev,
        [label]: data?.name,
      }));
    } else if (label === "steps") {
      setFormData((prev) => ({
        ...prev,
        steps: data.map((item) => item.id),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [label]: { id: data?.id, name: data?.name },
      }));
    }
    clearSearch();
  };

  return (
    <div className="cu-setup-create-container">
      {selectedOption?.value !== "Medicine Name" &&
        selectedOption?.value !== "Add Translation" &&
        selectedOption?.value !== "Roles and Permission" &&
        selectedOption?.value !== "Users" &&
        selectedOption?.value !== "Medicine Stock" &&
        selectedOption?.value !== "Batch" &&
        selectedOption?.value !== "Lab Tests" &&
        selectedOption?.value !== "Lab Tests Threshold" && (
          <form
            className={
              selectedOption?.fields?.some(
                (field) => field.type === "custom-field"
              )
                ? ""
                : "cu-setup-create-form"
            }
            onSubmit={handleSave}
          >
            <div
              className={
                selectedOption?.fields?.some(
                  (field) => field.type === "custom-field"
                )
                  ? ""
                  : "cu-setup-create-form-input-container"
              }
            >
              {selectedOption?.fields?.map((field, idx) => {
                // console.log(field);
                if (field?.type === "custom-field") {
                  return (
                    <>
                      <div className="w-[20%]">
                        <CuInput
                          required
                          disabled={mode === "view"}
                          label={"Step Name"}
                          placeholder={"Enter a Step Name"}
                          value={
                            formData[
                              field?.label?.replace(/ /g, "_").toLowerCase()
                            ]
                          }
                          onChange={(e) =>
                            handleChange(e.target.value, field?.label)
                          }
                        />
                      </div>

                      {/* <label>Form Creation</label> */}
                      <StepCreation />
                    </>
                  );
                }
                if (field?.label === "Discount") {
                  return (
                    <div key={field?.id} className="cu-setup-create-form-input">
                      <div className="cu-setup-form-discount-input">
                        <label>{field?.label}</label>
                        <input type="checkbox" />
                      </div>
                      <CuInput
                        type={field?.type}
                        required={field?.required}
                        disabled={mode === "view"}
                        value={
                          formData[
                            field?.label?.replace(/ /g, "_").toLowerCase()
                          ]
                        }
                        onChange={(e) =>
                          handleChange(e.target.value, field?.label)
                        }
                      />
                    </div>
                  );
                }
                if (
                  selectedOption?.value === "Service Master" &&
                  field?.label === "Service Type"
                ) {
                  return (
                    <div key={idx} className="cu-setup-create-form-input">
                      <CuSuggestionBox
                        options={serviceTypes}
                        label={field?.label}
                        renderKey={"name"}
                        searchInput={searchInput?.serviceType}
                        setSearchInput={(val) =>
                          handleSearch(val, "serviceType")
                        }
                        searchable
                        disabled={mode === "view"}
                        value={formData?.service_type?.name}
                        onChange={(val) => handleChange(val, field?.label)}
                        handleSelectOption={(data) =>
                          handleSelectOption(data, "service_type")
                        }
                      />
                    </div>
                  );
                }
                if (field?.label === "Transaction type") {
                  return (
                    <div key={idx} className="cu-setup-create-form-input">
                      <label>{field?.label}</label>
                      <CuDropdown
                        options={transactionTypeOptions}
                        disabled={mode === "view"}
                        value={
                          formData[
                            field?.label?.replace(/ /g, "_").toLowerCase()
                          ]
                        }
                        onChange={(val) => handleChange(val, field?.label)}
                      />
                    </div>
                  );
                }
                if (field?.label === "Select Item") {
                  return (
                    <div key={field?.id} className="cu-setup-create-form-input">
                      {/* <label>{field?.label}</label> */}
                      <CuSuggestionBox
                        options={items}
                        label={field?.label}
                        renderKey={"name"}
                        searchable
                        disabled={mode === "view"}
                        searchInput={searchInput?.item}
                        value={formData?.item?.name}
                        onChange={(val) => handleChange(val, "item")}
                        setSearchInput={(val) => handleSearch(val, "item")}
                        handleSelectOption={(data) =>
                          handleSelectOption(data, "item")
                        }
                      />
                    </div>
                  );
                }
                if (field?.label === "Select Location") {
                  return (
                    <div key={field?.id} className="cu-setup-create-form-input">
                      {/* <label>{field?.label}</label> */}
                      <CuSuggestionBox
                        options={locations}
                        label={field?.label}
                        renderKey={"name"}
                        searchable
                        disabled={mode === "view"}
                        searchInput={searchInput?.ward}
                        value={formData?.ward?.name}
                        onChange={(val) => handleChange(val, "ward")}
                        setSearchInput={(val) => handleSearch(val, "ward")}
                        handleSelectOption={(data) =>
                          handleSelectOption(data, "ward")
                        }
                      />
                    </div>
                  );
                }
                if (
                  field?.label === "Select Steps" &&
                  field?.type === "multi-select"
                ) {
                  return (
                    <div>
                      <CuMultiSelectBox
                        capitalize
                        label={field.label}
                        placeholder="Select options..."
                        options={stepOptions}
                        renderKey="text"
                        searchable={true}
                        handleSelectOptions={(data) => {
                          handleSelectOption(data, "steps");
                        }}
                        onChange={(val) => {
                          handleSearch(val, "steps");
                        }}
                        defaultSelectedItems={[
                          { id: 2, text: "PATIENT DETAILS" },
                        ]} // Pre-filled items
                      />
                      {/* <CuInput
                        type="text"
                        label="Select Steps"
                        // onClick={handleBatchInputClick}
                        // value={batchNos}
                        // loading={batchLoading}
                        position="calc(50% - -3px)"
                        // disabled={isView || !pline?.medicine_id}
                      /> */}
                      {/* {isBatchSuggestion &&
                        pline?.medicine_stock?.length > 0 && (
                          <div className="flex flex-col absolute border rounded z-[5] bg-[#FFFFFF]">
                            {pline?.medicine_stock?.map((batch) => (
                              <BatchSuggestionList
                                key={batch?.batch_id}
                                batch={batch}
                                handleSelectBatch={handleSelectBatch}
                                getCheckedBatches={getCheckedBatches}
                                idx={idx}
                              />
                            ))}
                          </div>
                        )} */}
                    </div>
                  );
                }
                if (field?.label === "Select services") {
                  return (
                    <div
                      key={field?.id}
                      className="cu-setup-services-dropdown-container"
                    >
                      <div className="cu-setup-services-dropdown">
                        <label>{field?.label}</label>
                        <CuDropdown
                          options={servicesOptions}
                          onChange={(val) => handleChange(val, field?.label)}
                          searchable
                          onSearch={(val) => handleSearch(val, "services")}
                          disabled={mode === "view"}
                          clearSearch
                        />
                      </div>
                      <div className="cu-setup-selected-services">
                        {formData?.services?.map((service) => (
                          <div key={service?.id} className="cu-setup-service">
                            <span>{service?.name_of_service}</span>
                            <span>
                              <img
                                src={CLOSE_ICON}
                                alt="close"
                                className="cu-setup-service-delete-icon"
                                onClick={() => handleDeleteService(service)}
                              />
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }
                if (field?.label === "Currency") {
                  return (
                    <div key={field?.id} className="cu-setup-create-form-input">
                      <label>{field?.label}</label>
                      <CuDropdown
                        options={field?.options}
                        // options={servicesOptions}
                        onChange={(val) => handleChange(val, field?.label)}
                        value={"INR"}
                        disabled={mode === "view"}
                      />
                    </div>
                  );
                }
                if (field?.label === "Select Medicines") {
                  return (
                    <div
                      key={field?.id}
                      className="cu-setup-services-dropdown-container"
                    >
                      <div className="cu-setup-services-dropdown">
                        <label>{field?.label}</label>
                        <CuDropdown
                          options={medicineOptions}
                          // value={1}
                          onChange={(val) => handleChange(val, field?.label)}
                          onSearch={(val) => handleSearch(val, "medicine")}
                          disabled={mode === "view"}
                          searchable
                        />
                      </div>
                      <div className="cu-setup-selected-services">
                        {formData?.medicine_data?.map((medicine) => (
                          <div
                            key={medicine?.id}
                            className="cu-setup-service pl-1"
                          >
                            <span>
                              {medicine?.medicine_name ||
                                medicine?.medicineName}
                            </span>
                            <span>
                              <img
                                src={CLOSE_ICON}
                                alt="close"
                                className="cu-setup-service-delete-icon"
                                onClick={() => handleDeleteMedicine(medicine)}
                              />
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }
                if (field?.label === "Group For") {
                  return (
                    <div key={field?.id} className="cu-setup-create-form-input">
                      <label>{field?.label}</label>
                      <CuDropdown
                        options={tagTypeOptions}
                        searchable
                        disabled={mode === "view"}
                        value={
                          formData[
                            field?.label?.replace(/ /g, "_").toLowerCase()
                          ]
                        }
                        onChange={(val) => handleChange(val, field?.label)}
                        onSearch={(searchVal) =>
                          handleSearch(searchVal, "tagType")
                        }
                      />
                    </div>
                  );
                }
                if (field?.label === "Select Tags") {
                  return (
                    <div
                      key={field?.id}
                      className="cu-setup-services-dropdown-container"
                    >
                      <div className="cu-setup-create-form-input">
                        <label>{field?.label}</label>
                        <CuDropdown
                          options={tagOptions}
                          searchable
                          disabled={mode === "view"}
                          clearSearch
                          // value={
                          //   formData[
                          //     field?.label?.replace(/ /g, "_").toLowerCase()
                          //   ]
                          // }
                          onChange={(val) => handleChange(val, field?.label)}
                          onSearch={(searchVal) =>
                            handleSearch(searchVal, "tag")
                          }
                        />
                      </div>
                      <div className="cu-setup-selected-services">
                        {formData?.group_item?.map((tag) => (
                          <div key={tag?.id} className="cu-setup-service">
                            <span>{tag?.name}</span>
                            <span>
                              <img
                                src={CLOSE_ICON}
                                alt="close"
                                className="cu-setup-service-delete-icon"
                                onClick={() => handleDeleteTag(tag)}
                              />
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }
                // if (
                //   selectedOption?.value === "Medicine Stock" &&
                //   field?.label === "Medicine Name"
                // ) {
                //   return (
                //     <div key={field?.id} className="cu-setup-create-form-input">
                //       <CuSuggestionBox
                //         options={medicineData}
                //         label={field?.label}
                //         renderKey={"medicine_name"}
                //         searchInput={searchInput?.medicine}
                //         setSearchInput={(val) => handleSearch(val, "medicine")}
                //         searchable={true}
                //         disabled={mode === "view"}
                //         value={formData?.medicine_name}
                //         onChange={(val) => handleChange(val, field?.label)}
                //         handleSelectOption={(data) =>
                //           handleSelectOption(data, "medicine_name")
                //         }
                //       />
                //     </div>
                //   );
                // }
                // if (
                //   selectedOption?.value === "Medicine Stock" &&
                //   field?.label === "UOM"
                // ) {
                //   return (
                //     <div key={field?.id} className="cu-setup-create-form-input">
                //       <CuSuggestionBox
                //         options={unitData}
                //         label={field?.label}
                //         renderKey={"name"}
                //         searchInput={searchInput?.uom}
                //         setSearchInput={(val) => handleSearch(val, "uom")}
                //         searchable
                //         disabled={mode === "view"}
                //         value={formData?.uom}
                //         onChange={(val) => handleChange(val, field?.label)}
                //         handleSelectOption={(data) =>
                //           handleSelectOption(data, "uom")
                //         }
                //       />
                //     </div>
                //   );
                // }
                return (
                  <div key={field?.id} className="cu-setup-create-form-input">
                    <CuInput
                      type={field?.type}
                      required={field?.required}
                      label={field?.label}
                      disabled={mode === "view"}
                      value={
                        formData[field?.label?.replace(/ /g, "_").toLowerCase()]
                      }
                      onChange={(e) =>
                        handleChange(e.target.value, field?.label)
                      }
                    />
                  </div>
                );
              })}
            </div>
            {selectedOption?.value === "Customer Details" && (
              <CustomerAddressForm
                setAddress={setAddress}
                billing_address={address.billing_address}
                communication_address={address.communication_address}
              />
            )}
            <div className="cu-setup-create-form-btn-container">
              {mode !== "view" && (
                <button
                  className={`cu-setup-create-form-btn cu-setup-create-form-save-btn`}
                  type="submit"
                >
                  {postMutation.isLoading || updateMutation.isLoading ? (
                    <CuSpinner />
                  ) : (
                    "Save"
                  )}
                </button>
              )}
              {mode === "view" && (
                <button
                  className={`cu-setup-create-form-btn cu-setup-create-form-save-btn`}
                  type="submit"
                  onClick={handleEdit}
                >
                  Edit
                </button>
              )}
              <button
                className={`cu-setup-create-form-btn cu-setup-create-form-cancel-btn`}
                type="button"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      {selectedOption?.value === "Medicine Name" && (
        <MedicineDataForm
          handleCancel={handleCancel}
          handleEdit={handleEdit}
          selectedOption={selectedOption}
          mode={mode}
          editData={editData}
        />
      )}
      {selectedOption?.value === "Invoice Details" && (
        <InvoiceDetails institutionId={id} />
      )}
      {selectedOption?.value === "Add Translation" && (
        <LanguageTranslation
          handleEdit={handleEdit}
          handleCancel={handleCancel}
          editData={editData}
          mode={mode}
        />
      )}
      {selectedOption?.value === "Users" && (
        <UserCreateRoles mode={mode} id={id} />
      )}
      {selectedOption?.value === "Roles and Permission" && (
        <CreateRoles mode={mode} />
      )}
      {selectedOption?.value === "Medicine Stock" && (
        <MedicineStockForm
          mode={mode}
          handleCancel={handleCancel}
          handleEdit={handleEdit}
          id={id}
        />
      )}
      {selectedOption?.value === "Batch" && (
        <BatchForm
          mode={mode}
          id={id}
          handleCancel={handleCancel}
          handleEdit={handleEdit}
        />
      )}
      {selectedOption?.value === "Lab Tests" && (
        <LabTestForm
          mode={mode}
          id={id}
          handleCancel={handleCancel}
          handleEdit={handleEdit}
        />
      )}
      {selectedOption?.value === "Lab Tests Threshold" && (
        <ThresholdForm
          mode={mode}
          id={id}
          handleCancel={handleCancel}
          handleEdit={handleEdit}
        />
      )}
    </div>
  );
};

export default SetupForm;
